import { TextFieldProps } from "@mui/material";

export const constants = {
  variant: "outlined" as TextFieldProps["variant"],
};
